import { useEffect, useMemo, useState } from 'react';
import { useQueryParams } from '@/hooks';
import { parseParamsFromParams } from '@/utils';
import { AssetsFilter } from '../models';

const useAssetsFilter = () => {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: AssetsFilter = useMemo(
    () => ({
      typeId: '',
      brandId: '',
      modelId: '',
      statuses: undefined,
      cityId: [],
      userId: '',
      officeId: '',
      barcode: '',
    }),
    []
  );

  const [filter, setFilter] = useState<AssetsFilter>(() => {
    const brandIdParam = getQueryParam('brandId') || '';
    const modelParam = getQueryParam('model') || '';
    const statusesParam = getQueryParam('statuses') || '';
    const cityParam = getQueryParam('cityId') || '';
    const userParam = getQueryParam('userId') || '';
    const officeParam = getQueryParam('officeId') || '';
    const barcodeParam = getQueryParam('barcode') || '';

    return {
      typeId: getQueryParam('typeId') || initialFilter.typeId,
      brandId: brandIdParam || initialFilter.brandId,
      modelId: modelParam || initialFilter.modelId,
      statuses: parseParamsFromParams(statusesParam) || initialFilter.statuses,
      cityId: parseParamsFromParams(cityParam) || initialFilter.cityId,
      userId: userParam || initialFilter.userId,
      officeId: officeParam || initialFilter.officeId,
      barcode: barcodeParam || initialFilter.barcode,
    };
  });

  useEffect(() => {
    setQueryParams({
      typeId: filter.typeId,
      brandId: filter.brandId,
      modelId: filter.modelId,
      statuses: filter.statuses?.toString(),
      cityId: filter.cityId.toString(),
      userId: filter.userId,
      officeId: filter.officeId,
      barcode: filter.barcode,
      page: getQueryParam('page') || '1',
      pageSize: getQueryParam('pageSize') || '10',
    });
  }, [filter]);

  return { filter, initialFilter, setFilter };
};

export default useAssetsFilter;
